import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectImage16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMediaObjectImage16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 3H3a1 1 0 0 0-1 1v4.617L3.743 7.57l.265-.159.26.166L9 10.59V4a1 1 0 0 0-1-1m1 8.775L3.992 8.588 2 9.783V12a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8.5 2.5A.5.5 0 0 1 12 4h2.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5M12 7a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1zM6.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectImage16);
